// extracted by mini-css-extract-plugin
export default {"infoBlock":"InfoBlock_infoBlock__pMRmm","topBlock":"InfoBlock_topBlock__b3SDL","line":"InfoBlock_line__EP12s","bottomBlock":"InfoBlock_bottomBlock__TVBkf"};